module.exports = __webpack_public_path__ + "ptc_nakagawa_C2.14b8edde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_C2.jpg
// module id = F1c5
// module chunks = 0